module.exports = __webpack_public_path__ + "static/grid-angle.75913792.jpg";